import React, {useState} from "react";


function IntegerField({fieldObj, fieldIndex, fieldUpdatedFunction, readOnly, singleLocationMode}){
    const [text, setText] = useState(singleLocationMode || readOnly ? fieldObj.text : undefined)
    const [dynamicStyle, setDynamicStyle] = useState("form-control text-input mt-1")

    const textChanged = (event) => {
        const isValid = event.target.validity.valid
        if(isValid){
            setDynamicStyle("form-control text-input mt-1")
            fieldObj.text = event.target.value
            fieldUpdatedFunction(fieldObj)
        } else {
            setDynamicStyle("form-control text-input mt-1 border border-danger")
        }
        setText(event.target.value)
    }

    const isDisabled = () => {
        if(readOnly){
            return true
        } else {
            singleLocationMode ? false : !fieldObj.bulkAllowed
        }
    }
    return(
        <div>
            <input key={"IntegerField -" + fieldObj.fieldId + fieldIndex}
                   placeholder={"Enter " + fieldObj.fieldDisplayName}
                   value={text}
                   pattern={"[0-9]*"}
                   onChange={e => textChanged(e)}
                   className={dynamicStyle}
                   disabled={isDisabled()}
                   maxLength={fieldObj.maxCharacters}
            />
        </div>
    )
}

export default IntegerField